import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import { COMPONENT_TYPE, IColors, IConferenceItem } from '../../interfaces/Conference';
import {
    Col1,
    Col2,
    Col3,
    DescAccomodation,
    DescAccomodations,
    Description,
    Room,
    RoomRow,
    Rooms,
    Title,
    TitleSymbol,
    Wrapper,
} from './ConferenceAccomodation.elements';

interface ConferenceProps {
    colors?: IColors;
    conf?: IConferenceItem;
}

const ConferenceAccomodationTemplate: FC<ConferenceProps> = ({ colors, conf }) => {
    const { t } = useTranslations();

    return (
        <Wrapper id={`confSection${COMPONENT_TYPE.ACCOMODATION}`}>
            <Title colors={colors}>
                {t('conference.component.accomodation.title')}
                <TitleSymbol colors={colors} />
            </Title>

            <Description
                colors={colors}
                dangerouslySetInnerHTML={{ __html: conf?.conference?.accomodation?.blockFirst }}
                withoutSidePadding
            ></Description>

            {conf?.conference?.accomodation?.rooms.length > 0 && (
                <>
                    <Rooms>
                        <Room>
                            <Col1 isHead colors={colors}>
                                Název
                            </Col1>
                            <Col2 isHead colors={colors}>
                                Typ pokoje
                            </Col2>
                            <Col3 isHead colors={colors}>
                                Cena
                            </Col3>
                        </Room>
                        {conf?.conference?.accomodation?.rooms.map((item, index) => (
                            <RoomRow key={`accRoom${index}`} colors={colors}>
                                <Col1 colors={colors}>{item.name}</Col1>
                                <Col2 colors={colors}>{item.type}</Col2>
                                <Col3 colors={colors}>{item.price}</Col3>
                            </RoomRow>
                        ))}
                    </Rooms>
                </>
            )}

            {conf?.conference?.accomodation?.descriptions.length > 0 && (
                <>
                    <DescAccomodations>
                        {conf?.conference?.accomodation?.descriptions.map((item, index) => (
                            <DescAccomodation
                                key={`accDesc${index}`}
                                oneNight={conf?.conference?.accomodation?.descriptions.length === 1}
                                dangerouslySetInnerHTML={{ __html: item.name }}
                            ></DescAccomodation>
                        ))}
                    </DescAccomodations>
                </>
            )}

            <Description
                withBackground
                colors={colors}
                dangerouslySetInnerHTML={{ __html: conf?.conference?.accomodation?.blockSecond }}
            ></Description>
        </Wrapper>
    );
};

export default ConferenceAccomodationTemplate;
